'use client';

import { startTransition } from 'react';
import { translateInline } from '@/globals/translate/translateInline';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { textBlock } from '@/uiPrimitives/typography/text';
import { useSelectedFilters } from './useSelectedFilters';

const hasSelectedFilters = (selectedFilters: Map<string, Set<string>>) => {
	for (const selectedFilter of selectedFilters.values()) {
		if (selectedFilter.size > 0) {
			return true;
		}
	}

	return false;
};

export const ClearAllFiltersButton = () => {
	const [selectedFilters, navigateFilters] = useSelectedFilters();

	if (!hasSelectedFilters(selectedFilters)) {
		return null;
	}

	return (
		<button
			onClick={() => {
				startTransition(() => {
					navigateFilters({
						checked: false,
					});
				});
			}}
			className={classes(
				textBlock({
					capSize: '-1 | small',
					color: 'positiveBlue',
					textDecorationLine: 'underline',
				}),
			)}
			{...addTestSelector('uiClearAllFiltersButton')}
		>
			{translateInline({
				en: 'Clear all filters',
				nl: 'Alle filters wissen',
			})}
		</button>
	);
};
